import { makeActionCreator } from '../../util/make_action_creator'

// CRUD
export const SET_DESTROYED = 'SET_DESTROYED'
export const setDestroyed = makeActionCreator(SET_DESTROYED, 'modelName', 'id')

export const SET_FETCHED = 'SET_FETCHED'
export const setFetched = makeActionCreator(
  SET_FETCHED,
  'primaryModel',
  'records',
)

export const buildPagedURL = (url, { after, before, limit, filter }) => {
  let urlPaged = after ? replaceUrlParam(url, 'after', after) : url
  urlPaged = before ? replaceUrlParam(urlPaged, 'before', before) : urlPaged
  urlPaged = limit ? replaceUrlParam(urlPaged, 'page_size', limit) : urlPaged
  urlPaged = filter ? setSearchParams(urlPaged, filter) : urlPaged
  return urlPaged
}

function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue === null) {
    paramValue = ''
  }
  const pattern = new RegExp('\\b(' + paramName + '=).*?(&|$)')
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2')
  }
  url = url.replace(/\?$/, '')
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue
}

function setSearchParams(url, filter) {
  url += url.indexOf('?') > 0 ? '&' : '?'
  const filterKeys = Object.keys(filter)
  filterKeys.forEach((key) => {
    if (!filter[key] || filter[key] === '') return
    if (url[url.length - 1] !== '?' && url[url.length - 1] !== '&') url += '&'
    url += key + '=' + filter[key]
  })
  return url
}
